module.exports = __webpack_public_path__ + "img/caomeixuelong.1c3da945.jpg";